import React, { useState } from "react";
import { FaBars, FaBell } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import avatar from "../data/avatar.jpg";
import { useStateContext } from "../contexts/ContextProvider";
import Notification from "./Notification";
import UserProfile from "./UserProfile";
import useNotifications from "../hooks/useNotifications";
import useUserProfile from "../hooks/useUserProfile";


const NavButton = ({ title, customFunc, icon, color, dotColor, showBadge }) => (
  <button
    type="button"
    title={title}
    onClick={customFunc}
    style={{
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: 'none',
      outline: 'none',
      padding: '0',
      backgroundColor: 'lightgray',
    }}
    className="rounded-full hover:bg-light-gray relative"
  >
    <div className="flex items-center justify-center w-full h-full">
      {showBadge && (
        <span
          style={{ background: dotColor }}
          className="absolute left-[7px] bottom-[20px] text-white text-xs font-semibold rounded-full px-2 py-0.5 shadow-md notification-badge"
        >
          {showBadge > 99 ? "99+" : showBadge}
        </span>
      )}
      <div className="flex items-center justify-center w-full h-full">
        {icon}
      </div>
    </div>
  </button>
);


const Navbar = ({ notificationTrigger }) => {
  const {
    currentColor,
    setActiveMenu,
    handleClick,
    isClicked,
  } = useStateContext();

  const user = useUserProfile();
  const [showCloseButton, setShowCloseButton] = useState(false);
  const [openCount, setOpenCount] = useState(0);
  const { notifications, unreadCount, markAsRead, setNotifications } =
    useNotifications(`${openCount}-${notificationTrigger}`);

  const toggleNotification = () => {
    if (!isClicked.notification) {
      setOpenCount((c) => c + 1);
    }
    handleClick("notification");
    setShowCloseButton((prev) => !prev);
  };

  return (
    <div className="flex justify-between px-4 py-3 relative border-b border-gray">
      <NavButton
        title="Menu"
        customFunc={() => setActiveMenu((prev) => !prev)}
        color={currentColor}
        icon={<FaBars />}
      />

      <div className="flex items-center">
        <NavButton
          title="Notifications"
          dotColor="#fba86f"
          customFunc={toggleNotification}
          color={currentColor}
          icon={<FaBell />}
          showBadge={unreadCount > 0 ? unreadCount : null}
        />

        <div
          className="flex items-center gap-x-1 cursor-pointer p-2 hover:bg-gray-50 rounded-lg transition-all duration-200"
          onClick={() => handleClick("userProfile")}
        >
          <img className="rounded-full h-10 w-10 object-contain" src={avatar} alt="user" />

          <span className="text-gray-400 font-bold text-sm">
            {user?.user?.first_name} {user?.user?.last_name}
          </span>

          <MdKeyboardArrowDown size={30} className="text-gray-400" />
        </div>

        {isClicked.notification && (
          <Notification
            notifications={notifications}
            unreadCount={unreadCount}
            markAsRead={markAsRead}
            setShowCloseButton={setShowCloseButton}
          />
        )}
        {isClicked.userProfile && <UserProfile user={user} />}
      </div>
    </div>
  );
};

export default Navbar;
